<div class="container p-0-20">
  <p>
    Proiectul nu surprinde doar prin oferta financiară avantajoasă, dar și prin <b>accesibilitate către centrul orașului</b>. Fie că mergi pe jos sau cu mașina, în <b>10 minute (4 km)</b> ai ajuns la Piața Unirii. Nu ne crezi? <b>Ți-am pregătit o hartă interactivă care să te ajute.</b>
    <br>
    De asemenea, mai jos găsești și câteva puncte de interes predefinite.
  </p>
</div>
<app-gmap
  [latitude]="agencyService.agency.latitude"
  [longitude]="agencyService.agency.longitude"
  [pathColor]="'#7cb650'"
  [travelModes]="travelModes"
  id="map"
>
</app-gmap>
<div
  fxLayout="column"
  fxLayoutAlign="center center"
  class="container"
>
  <p
    class="hotspots-info p-0-20"
  >
    {{ 'pages.localisation.subtitle' | translate }}
  </p>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center start"
    class="hotspots"
  >
    <div
      *ngFor="let category of pointsOfInterestCategories"
      fxLayout="column"
      fxLayoutAlign="center start"
      class="hotspots-category"
    >
      <h1
        fxLayout="row"
        fxLayoutAlign="center start"
        class="hotspots-title"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="gradient-background"
        >
          <img
            [src]="category.icon"
            alt="category"
            class="hotspot-icon"
            loading="lazy"
          >
        </div>
        {{ category.title }}
      </h1>
      <h2
        *ngFor="let point of category.points"
        class="hotspot"
        (click)="onInterestPointClick(point)"
      >
        {{ point.title | truncate:45 }}
      </h2>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/localisation/localisation.component.html